import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import moment from 'moment';

@Directive({
    selector: '[appEndTimeValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: EndTimeValidator, multi: true }],
})
export class EndTimeValidator implements Validator {
    private _startTime: string = '';
    private _endTime: string = '';

    @Input()
    get startTime(): string {
        return this._startTime;
    }

    @Input() get endTime(): string {
        return this._endTime;
    }

    set startTime(value: string) {
        this._startTime = value;
    }

    set endTime(value: string) {
        this._endTime = value;
    }

    validate(): ValidationErrors | null {
        if (!this.startTime || !this.endTime) {
            return null;
        }

        const startMoment = moment(this.startTime, 'YYYY-MM-DD HH:mm:ss');
        const endMoment = moment(this.endTime, 'YYYY-MM-DD HH:mm:ss');

        if (!startMoment.isValid() || !endMoment.isValid()) {
            return null;
        }

        // 12 AM (00:00) is always valid as an end time
        if (endMoment.format('HH:mm') === '00:00') {
            return null;
        }

        // For all other cases, ensure end time is after start time
        if (endMoment.isBefore(startMoment)) {
            return { endTimeBeforeStart: true };
        }

        return null;
    }
}
